import React from "react";
import {Route} from "react-router-dom";
import {
    AVAILABLE_DETAIL_ROUTE,
    CONSULT_AVAILABLE_PTT_ROUTE,
    SEND_AVAILABLE_DETAIL_ROUTE
} from "../../utils/constants/RoutesConstants";
import AvailableDetail from "../../pages/operation/availableValuesPTM/availableDetail";
import SendAvailableDetail from "../../pages/operation/availableValuesPTM/sendAvailableDetail";
import AvailablePTT from "../../pages/operation/availableValuesPTM/availablePTT";

const AvailableValuesRoutes = () => {
    return (
        <React.Fragment>
            <Route path={AVAILABLE_DETAIL_ROUTE} component={AvailableDetail}/>
            <Route path={SEND_AVAILABLE_DETAIL_ROUTE} component={SendAvailableDetail}/>
            <Route path={CONSULT_AVAILABLE_PTT_ROUTE} component={AvailablePTT}/>
        </React.Fragment>
    );
};

export default AvailableValuesRoutes;